import { post } from '../index';

export const assignUserToProject = data => {
  return post('/projects/share', data);
};
